import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import React from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { AppStore } from "../../stores/AppStore";
import { observable } from "mobx";
import { IEmpresa, newEmpresa } from "../../model";
import { EmpresaSelect, filterEmpresa, renderEmpresa } from "../empresa/EmpresaSelect";
import { Alert, Alignment, Button, Classes, Dialog, FormGroup, HTMLSelect, Icon, Tag } from "@blueprintjs/core";
import { formatCnpj, sortBy } from "../../utils";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { observer } from "mobx-react";
import { getTag } from "../utils/getStatus";
import { FaixaSimplesStore } from "../../stores/relatorio/FaixaSimplesStore";
import moment from "moment";
import { toast } from "react-toastify";

var debounce = require('lodash.debounce');

@observer
export default class FaixaSimplesPage extends React.Component {
  obs = observable({
    fetchOptions: {} as any,
    selectEmpresa: newEmpresa() as IEmpresa,
    open_solicitar: false as boolean,
    view_faixa_simples: false as boolean,
    erros: "" as string,
    selectEmpresaSolicitacao: newEmpresa() as IEmpresa,
    tarefas_page: 1 as number
  });

  constructor(props: {}) {
    super(props);
    AppStore.setTitle("Faixa Simples Nacional");
  }

  handlePageChange = async () => {
    this.obs.tarefas_page = 1
    await FaixaSimplesStore.handleTasksPaged(this.obs.tarefas_page, this.obs.selectEmpresa.cnpj);
  };

  handleSelectEmpresa = (empresa: IEmpresa) => {
    this.obs.selectEmpresa = empresa;
  };

  clearEmpresa = () => {
    this.obs.selectEmpresa = newEmpresa();
  };

  handleConcluirSolicitacao = async () => {
    const cnpj = this.obs.selectEmpresaSolicitacao?.cnpj;
    const razao_social = this.obs.selectEmpresaSolicitacao?.razao_social;

    await FaixaSimplesStore.handleSolicitarRelatorio(cnpj, razao_social);

    if (cnpj) {
      this.obs.selectEmpresa = this.obs.selectEmpresaSolicitacao;
    }

    this.obs.tarefas_page = 1;
    
    await FaixaSimplesStore.handleTasksPaged(
      this.obs.tarefas_page,
      this.obs.selectEmpresa?.cnpj || ""
    );

    this.closeModalSolicitacao();
  };

  resetModalSolicitacao = () => {
    this.obs.selectEmpresaSolicitacao = newEmpresa();
  };

  closeModalSolicitacao = () => {
    FaixaSimplesStore.obs.open_solicitar = false;
    this.resetModalSolicitacao();
  };

  /**
  * Formata uma data adicionando 3 horas e exibe a data e hora formatadas.
  * 
  * @param {string} cell - Data a ser formatada.
  * @param {object} row - Objeto representando a linha.
  * @returns {string} - Data e hora formatadas.
  */

  dateFormatter(cell, row) {

    if (cell) {

      return moment(cell).add(3, "hour").format("DD/MM/YYYY") + " às " + moment(cell).add(3, "hour").format("HH:mm");

    }

    return "Sem atualização";

  };

  /**
  * Exibe os detalhes de erros associados a uma linha.
  * 
  * @param {object} row - Objeto representando a linha.
  */
  handleViewErros = async (row: any) => {
    this.obs.erros = row.error

    if (this.obs.erros != "" && this.obs.erros != null) {
      this.obs.view_faixa_simples = true
    } else {
      toast.warn("Nenhum erro encontrado!", {});
      return
    }
  };

  /**
  * Renderiza um botão para visualizar os detalhes de uma linha.
  * 
  * @param {any} cell - Célula da tabela (não utilizado).
  * @param {object} row - Objeto representando a linha.
  * @returns {JSX.Element} - Botão para visualizar detalhes.
  */
  viewErros = (cell, row) => {
    return (
      <MDBBtn
        disabled={!row._id}
        color="default"
        rounded
        size="sm"
        onClick={(e) => this.handleViewErros(row)}
      >
        <img src="/images/view.png" width="18px" />
      </MDBBtn>
    );
  }

  /**
  * Fecha a exibição de erros e limpa o conteúdo dos erros.
  */
  onCloseErros() {
    this.obs.view_faixa_simples = false
    this.obs.erros = ""
  }

  cnpjFormatter(cell, row) {

    if(!row.cnpj) return "N/A"

    if (row.cnpj) {
      let emp = EmpresaStore.getByCnpj(row.cnpj);
      if (emp) {
        return `${emp.razao_social.substring(0, 30)} - ${formatCnpj(row.cnpj)}`
      }
    }
    return ""

  };

  statusFormatter(cell, row) {
    return getTag(row.status, "relatorio");
  }

  async handleOpenCreate() {

    FaixaSimplesStore.obs.open_solicitar = true

  }

  handleSelecionaEmpresaSolicitacao = (empresa: IEmpresa) => {
    this.obs.selectEmpresaSolicitacao = empresa || newEmpresa();
  };

  render() {
    const empresaText =
      this.obs.selectEmpresa?.cnpj && this.obs.selectEmpresa.cnpj !== ""
        ? `${this.obs.selectEmpresa.razao_social.substring(0, 38)}... (${formatCnpj(this.obs.selectEmpresa.cnpj)})`
        : "Selecione uma empresa";



    function fileFormatter(cell, row) {
      return (
        <>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            disabled={row.status != 2}
            onClick={() => FaixaSimplesStore.handleDownloadArquivoRelatorio(row.relatorio_id, row.cnpj)}
          >
            <img src="/images/download.svg" />
          </MDBBtn>
        </>
      );
    }

    return (
      <>
        <MDBRow>
          <MDBCol md="4">
            <FormGroup className="empresaSelect" label="Empresa">
              <EmpresaSelect
                items={EmpresaStore.sortedEmpresas.filter(x => { return x.simples_nacional })}
                itemRenderer={renderEmpresa}
                itemPredicate={filterEmpresa}
                onItemSelect={(e: IEmpresa) => (this.obs.selectEmpresa = e)}
                inputProps={{ placeholder: "Filtrar uma empresa" }}
              >
                <Button
                  text={empresaText}
                  alignText={Alignment.LEFT}
                  rightIcon={
                    this.obs.selectEmpresa?.cnpj ? (
                      <Icon
                        className="clear-icon-empresa"
                        icon="cross"
                        onClick={(ev) => {
                          ev.stopPropagation();
                          this.clearEmpresa();
                        }}
                      />
                    ) : (
                      <Icon icon="double-caret-vertical" style={{ padding: 5 }} />
                    )
                  }
                />
              </EmpresaSelect>
            </FormGroup>
          </MDBCol>

          <MDBCol md="2">
            <MDBBtn
              className="btnDefault btnBuscarNfe mt25"
              onClick={() => this.handlePageChange()}
            >
              Buscar
            </MDBBtn>
          </MDBCol>
        </MDBRow>

        <MDBRow>
          <MDBCol md="12" className="">
            {/* <MDBBtn
              className="btnDefault btnBuscarNfe"
              style={{ marginRight: 10, float: "left" }}>
              Exportar planilha
            </MDBBtn> */}
            <MDBBtn
              className="btnDefault btnBuscarNfe"
              onClick={(e) => this.handleOpenCreate()}
              style={{ marginRight: 10, float: "left" }}>
              Solicitar relatório
            </MDBBtn>
          </MDBCol>
        </MDBRow>

        <div>
          <BootstrapTable className="TableDefault" ref="table" data={sortBy(FaixaSimplesStore.obs.tasks_faixa_simples, "inserted_at").reverse()}>
            <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%">#</TableHeaderColumn>
            <TableHeaderColumn dataFormat={this.cnpjFormatter} width="20%">Empresa</TableHeaderColumn>
            <TableHeaderColumn dataFormat={this.dateFormatter} dataField="inserted_at" width="10%" dataAlign="center">Data solicitação</TableHeaderColumn>
            <TableHeaderColumn dataFormat={this.statusFormatter} dataField="situacao" width="30%" dataAlign="center">Status tarefa</TableHeaderColumn>
            <TableHeaderColumn dataFormat={this.dateFormatter} dataField="_modifiedTS" width="10%">Ultima Atualização</TableHeaderColumn>
            <TableHeaderColumn dataFormat={this.viewErros} dataAlign="center" width="5%">Erros</TableHeaderColumn>
            <TableHeaderColumn dataFormat={fileFormatter} width="5%">Arquivo</TableHeaderColumn>
          </BootstrapTable>
        </div>

        <Alert
          confirmButtonText="Fechar"
          isOpen={this.obs.view_faixa_simples}
          onConfirm={() => this.onCloseErros()}
          onClose={() => this.onCloseErros()}
          canOutsideClickCancel={true}
          className="AlertUser"
          intent="primary"
        >
          <h3 className="titleProccess titleCnae">Logs Erros</h3>
          <br />
          <p>{this.obs.erros}</p>
        </Alert>

        <Alert
          confirmButtonText="Fechar"
          isOpen={this.obs.view_faixa_simples}
          onConfirm={() => this.onCloseErros()}
          onClose={() => this.onCloseErros()}
          canOutsideClickCancel={true}
          className="AlertUser"
          intent="primary"
        >
          <h3 className="titleProccess titleCnae">Logs Erros</h3>
          <br />
          <p>{this.obs.erros}</p>
        </Alert>

        <Dialog
          isOpen={FaixaSimplesStore.obs.open_solicitar}
          onClose={this.closeModalSolicitacao}
          className="dialog-solicitar-faixa"
        >
          <h2 className="titleSEFAZ" style={{ marginBottom: 5 }}>Solicitar relatório</h2>
          <MDBRow>
            <MDBCol md="12">
              <FormGroup className="empresaSelect" label="Empresa" labelInfo={<div style={{ marginBottom: 2 }} />}>
                <EmpresaSelect
                  items={EmpresaStore.sortedEmpresas.filter(x => { return x.simples_nacional; })}
                  itemRenderer={renderEmpresa}
                  itemPredicate={filterEmpresa}
                  onItemSelect={(e: IEmpresa) => this.handleSelecionaEmpresaSolicitacao(e)}
                >
                  <Button
                    text={
                      this.obs.selectEmpresaSolicitacao.cnpj
                        ? `${this.obs.selectEmpresaSolicitacao.razao_social.substring(0, 38)}... (${formatCnpj(this.obs.selectEmpresaSolicitacao.cnpj)})`
                        : "Selecione uma empresa (opcional)"
                    }
                    alignText={Alignment.LEFT}
                    rightIcon={
                      this.obs.selectEmpresaSolicitacao.cnpj ? (
                        <Icon
                          className="clear-icon-empresa"
                          icon="cross"
                          onClick={(ev) => {
                            ev.stopPropagation();
                            this.handleSelecionaEmpresaSolicitacao(newEmpresa());
                          }}
                        />
                      ) : (
                        <Icon icon="double-caret-vertical" style={{ padding: 5 }} />
                      )
                    }
                  />
                </EmpresaSelect>
              </FormGroup>
            </MDBCol>
          </MDBRow>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Fechar" onClick={this.closeModalSolicitacao} />
            <Button text="Solicitar" intent="primary" onClick={this.handleConcluirSolicitacao} />
          </div>
        </Dialog>
      </>
    );
  }
}
